import {Box} from 'src/design/atoms/Box';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';
import {useFileUtilities} from '../FormFileDropzone/hooks/useFileUtilities';
import {FormViewLabel} from '../FormViewLabel';
import {FileListView} from './FileListView';

export interface FormViewFileListRowV2Props {
  field: IFormFieldV2;
  value: any;
}

export const FormViewFileListRowV2: React.FC<FormViewFileListRowV2Props> = ({
  field,
  value,
}) => {
  const {safeFileArrayParse} = useFileUtilities();
  const files = safeFileArrayParse(value);

  return (
    <Box data-testid={`form-view-${field.name}`}>
      <FormViewLabel>{field.label}</FormViewLabel>
      <FileListView
        files={files}
        renderAsImage={field.fileUploadOptions?.renderUploadsAsImage}
      />
    </Box>
  );
};
